const SET_MODULE = "SET_MODULE";
const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
const SET_MY_TIMES = "SET_MY_TIMES";
const SET_MY_TIME = "SET_MY_TIME";
const SET_MY_TIME_OFF_BALANCE = "SET_MY_TIME_OFF_BALANCE";
const SET_MY_TIME_OFF = "SET_MY_TIME_OFF";
const SET_REQUEST_TRAIL = "SET_REQUEST_TRAIL";
const SET_TEAM_TIME = "SET_TEAM_TIME";
const SET_EMPLOYEES_UNDER = "SET_EMPLOYEES_UNDER";
const SET_MY_PAYS = "SET_MY_PAYS";
const SET_MY_TASKS = "SET_MY_TASKS";
const SET_MY_TASKS_COUNT = "SET_MY_TASKS_COUNT";
const SET_MY_TASK = "SET_MY_TASK";
const SET_MY_PROFILE = "SET_MY_PROFILE";
const SET_MY_BENEFITS = "SET_MY_BENEFITS";
const SET_MY_CAREER = "SET_MY_CAREER";
const SET_BROWSE_JOBS = "SET_BROWSE_JOBS";
const SET_DASHBOARD_ANNOUNCEMENTS = "SET_DASHBOARD_ANNOUNCEMENTS";
const SET_DASHBOARD_MY_TASKS = "SET_DASHBOARD_MY_TASKS";
const SET_DASHBOARD_UPCOMING_EVENTS = "SET_DASHBOARD_UPCOMING_EVENTS";
const SET_PERMITTED_MODULES = "SET_PERMITTED_MODULES";
const SET_USER_MANAGEMENT = "SET_USER_MANAGEMENT";
const SET_ROLES = "SET_ROLES";
const SET_ROLES_ASSOCIATION = "SET_ROLES_ASSOCIATION";
const SET_ROLE_PERMISSIONS = "SET_ROLE_PERMISSIONS";
const SET_TIME_OFF_REQUEST_CREATED = "SET_TIME_OFF_REQUEST_CREATED";
const SET_DIRECT_DEPOSITS = "SET_DIRECT_DEPOSITS";
const SET_PAYROLL_ITEMS = "SET_PAYROLL_ITEMS";
const SET_PAYROLL_ITEM_DETAILS = "SET_PAYROLL_ITEM_DETAILS";
const SET_PAYROLL_CHECKS = "SET_PAYROLL_CHECKS";
const SET_PAYROLL_CHECK_DETAILS = "SET_PAYROLL_CHECK_DETAILS";
const SET_PAYROLL_TASK = "SET_PAYROLL_TASK";
const SET_PAYROLL_REGISTERED = "SET_PAYROLL_REGISTERED";
const SET_NEXT_STATUS_LIST_TASK = "SET_NEXT_STATUS_LIST_TASK";
const SET_ASSOCIATION_LIST = "SET_ASSOCIATION_LIST";
const SET_COST_CENTERS = "SET_COST_CENTERS";
const SET_USER_ASSIGNMENTS = "SET_USER_ASSIGNMENTS";
const SET_TIME_ENTRY_APPROVAL_REF_ID = "SET_TIME_ENTRY_APPROVAL_REF_ID";
const SET_PAY_CYCLES = "SET_PAY_CYCLES";
const SET_PAY_CYCLE_DETAIL = "SET_PAY_CYCLE_DETAIL";
const SET_TASK_PERMISSION = "SET_TASK_PERMISSION";
const SET_USER_GROUPS = "SET_USER_GROUPS";
const SET_ASSIGNMENT_HISTORY = "SET_ASSIGNMENT_HISTORY";
const SET_TIME_OFF_ENTRIES = "SET_TIME_OFF_ENTRIES";
const SET_TRANSACTION_DETAILS = "SET_TRANSACTION_DETAILS";
const SET_PUBLISHED_W2 = "SET_PUBLISHED_W2";
const SET_ATTRIBUTES = "SET_ATTRIBUTES";
const SET_DEPENDENTS = "SET_DEPENDENTS";
const SET_REQUESTS = "SET_REQUESTS";

export {
  SET_REQUESTS,
  SET_DEPENDENTS,
  SET_ATTRIBUTES,
  SET_PUBLISHED_W2,
  SET_TRANSACTION_DETAILS,
  SET_TIME_OFF_ENTRIES,
  SET_ASSIGNMENT_HISTORY,
  SET_USER_GROUPS,
  SET_TASK_PERMISSION,
  SET_PAY_CYCLE_DETAIL,
  SET_MODULE,
  SET_NOTIFICATIONS,
  SET_MY_TIMES,
  SET_MY_TIME,
  SET_MY_TIME_OFF_BALANCE,
  SET_MY_TIME_OFF,
  SET_REQUEST_TRAIL,
  SET_TEAM_TIME,
  SET_EMPLOYEES_UNDER,
  SET_MY_PAYS,
  SET_MY_TASKS,
  SET_MY_TASKS_COUNT,
  SET_MY_TASK,
  SET_MY_PROFILE,
  SET_MY_BENEFITS,
  SET_MY_CAREER,
  SET_BROWSE_JOBS,
  SET_DASHBOARD_ANNOUNCEMENTS,
  SET_DASHBOARD_MY_TASKS,
  SET_DASHBOARD_UPCOMING_EVENTS,
  SET_PERMITTED_MODULES,
  SET_USER_MANAGEMENT,
  SET_ROLES,
  SET_ROLES_ASSOCIATION,
  SET_ROLE_PERMISSIONS,
  SET_TIME_OFF_REQUEST_CREATED,
  SET_DIRECT_DEPOSITS,
  SET_PAYROLL_ITEMS,
  SET_PAYROLL_ITEM_DETAILS,
  SET_PAYROLL_CHECKS,
  SET_PAYROLL_CHECK_DETAILS,
  SET_PAYROLL_TASK,
  SET_PAYROLL_REGISTERED,
  SET_NEXT_STATUS_LIST_TASK,
  SET_ASSOCIATION_LIST,
  SET_COST_CENTERS,
  SET_USER_ASSIGNMENTS,
  SET_TIME_ENTRY_APPROVAL_REF_ID,
  SET_PAY_CYCLES
};
